import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditMembershipPlan = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Membership Plan'
      fields={fields}
      apiPath={`admin/membership_plans/${props.params.membershipPlanId}`}
      successRedirectPath='/membership/membership-plans'
      buildMenuItems={menuItems}
    />
  )
}

export default EditMembershipPlan
